export default __webpack_public_path__ + "static/media/Driving-SVG.144e8699.gif";